import {Directive} from '@angular/core';
import {BaseComponent} from '../../abstract/base.component';

@Directive()
export abstract class ManageCustomFieldsAction  extends BaseComponent {
  protected _createCustomFieldUrl: string;
  protected _updateCustomFieldUrl: string;
  protected createCustomField(postBody: {}) {
    this.loadFlag = true;
    this.dataManager.postRequest(this._createCustomFieldUrl, postBody, 0)
      .subscribe(
        (res) => {
          this.loadFlag = false;
          this.passCreateResponse(res);
        },
        (error) => {
          this.loadFlag = false;
          this.networkErrorHandler(error.error);
          this.passCreateError(error.error);
        }
      );
  }

  protected abstract passCreateResponse(res: any);
  protected abstract passCreateError(error: any);
}
